import { render, staticRenderFns } from "./SurgeryReservationList.vue?vue&type=template&id=5f33d8af&scoped=true"
import script from "./SurgeryReservationList.vue?vue&type=script&lang=js"
export * from "./SurgeryReservationList.vue?vue&type=script&lang=js"
import style0 from "./SurgeryReservationList.vue?vue&type=style&index=0&id=5f33d8af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33d8af",
  null
  
)

export default component.exports